"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _lodash = require("lodash");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

var DEFAULT_LABEL_COLOR = '#000000';

function Legend(props) {
  var items = props.items,
      activeItems = props.activeItems,
      _onChange = props.onChange,
      className = props.className,
      itemClassName = props.itemClassName,
      flexDirection = props.flexDirection,
      itemDirection = props.itemDirection,
      selectable = props.selectable,
      colorClassName = props.colorClassName,
      labelClassName = props.labelClassName,
      labelFontWeight = props.labelFontWeight,
      shape = props.shape;
  var parentClassName = (0, _classnames.default)('flex flex-wrap', {
    'flex-col lg:flex-row': flexDirection === 'row',
    'flex-col': flexDirection === 'column'
  }, className);
  var baseItemClassName = (0, _classnames.default)('p-2 text-sm flex', {
    'flex-row': itemDirection === 'row',
    'flex-col items-center': itemDirection === 'column',
    'cursor-pointer': selectable
  }, itemClassName);
  var baseColorClassName = (0, _classnames.default)('w-4 h-4 flex-shrink-0', {
    'mr-1': itemDirection === 'row',
    'mb-2 h-4': itemDirection === 'column',
    'rounded-full flex items-center justify-center': shape === 'circle'
  }, colorClassName);
  var baseLabelClassName = (0, _classnames.default)("font-".concat(labelFontWeight, " whitespace-no-wrap"), labelClassName);
  return _react.default.createElement("div", {
    className: parentClassName
  }, items.map(function (item) {
    return _react.default.createElement("div", {
      key: item.color,
      className: baseItemClassName
    }, _react.default.createElement("div", null, _react.default.createElement("label", {
      className: "flex items-center"
    }, selectable ? _react.default.createElement("input", {
      className: "mr-1",
      onChange: function onChange(e) {
        if (e.target.checked) {
          _onChange([].concat(_toConsumableArray(activeItems), [item.label]));
        } else {
          _onChange(activeItems.filter(function (v) {
            return v !== e.target.value;
          }));
        }
      },
      checked: (0, _lodash.includes)(activeItems, item.label),
      type: "checkbox",
      value: item.label
    }) : _react.default.createElement("div", {
      className: baseColorClassName,
      style: {
        backgroundColor: item.color
      }
    }), _react.default.createElement("div", {
      className: baseLabelClassName,
      style: {
        color: item.labelColor || DEFAULT_LABEL_COLOR
      }
    }, item.label))));
  }));
}

Legend.propTypes = {
  className: _propTypes.default.string,
  itemClassName: _propTypes.default.string,
  colorClassName: _propTypes.default.string,
  labelClassName: _propTypes.default.string,
  labelFontWeight: _propTypes.default.string,
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]).isRequired,
    color: _propTypes.default.string.isRequired,
    labelColor: _propTypes.default.string
  })).isRequired,
  selectable: _propTypes.default.bool,
  onChange: function onChange(props, propName) {
    if (props['selectable'] && (props[propName] === undefined || typeof props[propName] != 'function')) {
      return new Error('onChange is required when selectable.');
    }
  },
  activeItems: function activeItems(props, propName) {
    if (props['selectable'] && (props[propName] === undefined || !Array.isArray(props[propName]))) {
      return new Error('activeItems is required when selectable.');
    }
  },
  flexDirection: _propTypes.default.string,
  itemDirection: _propTypes.default.string,
  shape: _propTypes.default.string
};
Legend.defaultProps = {
  className: '',
  itemClassName: '',
  colorClassName: '',
  labelClassName: '',
  selectable: false,
  activeItems: null,
  onChange: null,
  flexDirection: 'row',
  itemDirection: 'row',
  labelFontWeight: 'semibold',
  shape: null
};

var _default = _react.default.memo(Legend);

exports.default = _default;